import { getColumnsFromMap, sorterDispatcher } from '@app/utils/table'

import type { ClusterColumns } from '../types'
import type { TranslationsConfigClustersDataSource } from '@app/types/dataSource/TranslationsConfigDataSource'
import type { Column } from '@app/components/base/Table/types'

const columnTitleMap: Record<keyof ClusterColumns, string> = {
  fromClusters: 'Кластер',
  toClusters: 'Кластер для транслирования',
  removeButton: ''
}

const getColumnsOptions = (): Array<Column<ClusterColumns>> => {
  const columnKeys = Object.keys(columnTitleMap) as Array<keyof ClusterColumns>

  return columnKeys.map(key => {
    const column: Column<ClusterColumns> = {
      key,
      width: '50%',
      sorter: (a, b) => sorterDispatcher(a[key], b[key])
    }

    return column
  })
}

const getColumns = (): Array<Column<TranslationsConfigClustersDataSource>> =>
  [
    ...getColumnsFromMap<ClusterColumns>({
      columnTitleMap,
      options: getColumnsOptions()
    })
  ] as Array<Column<TranslationsConfigClustersDataSource>>

export default getColumns
